export function getErrorMessage(config, error) {
  return config.errorCode[error.errorCode] || config.errorCode[error.resamaniaCode] || error.userMsg || config.errorCode.default;
}
